import {Grid, Skeleton} from '@mui/material';

export const DrawerContentBoardtemSkeleton = () => {
    return (
        <Grid container spacing={1} pl={1} pr={1} pt={1}>
            <Grid item xs={12}>
                <Skeleton variant="rectangular" width={'100%'} height={'40px'} style={{borderRadius: '10px'}} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant="rectangular" width={'100%'} height={'40px'} style={{borderRadius: '10px'}} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant="rectangular" width={'100%'} height={'40px'} style={{borderRadius: '10px'}} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant="rectangular" width={'100%'} height={'40px'} style={{borderRadius: '10px'}} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant="rectangular" width={'100%'} height={'40px'} style={{borderRadius: '10px'}} />
            </Grid>
        </Grid>
    );
};

export default DrawerContentBoardtemSkeleton;
